<template>
  <div>

    <div class="center big-padding">
      Souhaitez-vous supprimer le cantonnier <strong>{{cantonnier.nom}} {{cantonnier.prenom}} </strong> - <strong>{{cantonnier.arrondissement_id | arrondissementName}}</strong> ? Cela aura pour effet de ne plus l'afficher dans la liste des cantonniers disponible, par le maîtrise, lors de la phase de configuration initiale d'une session de travail.
    </div>

    <div class="buttons">
      <div class="btn btn-primary" v-on:click='confirm()'>
        Supprimer
      </div>

      <div class="btn btn-default" v-on:click="$emit('close')">
        Annuler
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../../store'
export default {
  props: [
    'cantonnier',
  ],
  methods: {
    confirm: function () {
      this.$store.dispatch('deactivateCantonnier', this.cantonnier)
      this.$emit('close')
    },
  },
}
</script>



// WEBPACK FOOTER //
// CantonniersDelete.vue?606d756a